export default __webpack_public_path__ + "static/media/587.ce10b557.jpg";